import React from "react";

// import NavigationBar from "../../components/navigation/NavigationBar";

import './footer.css';

const Footer = props => {

  let footerCls = "Footer";
  if (props.appNavState.active) {
    footerCls = "Footer menu-open";
  }
  return (
    <footer className={footerCls}>
      {/* <div className=""></div> */}
      {/* <NavigationBar {...props} cvParts={props.cvParts}/> */}
    </footer >
  );
};

export default Footer;
